import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Row } from '@tanstack/react-table';

import { Table } from 'components/Table';
import { useProsforaAuctionVolumes } from 'api';
import { useSelector } from 'store';
import ProsforaAuctionVolume from 'types/api/ProsforaAuctionVolume';

import useColumns from './hooks/useColumns';

import './AuctionVolumes.scss';
import { useIsLoggedIn } from '../../../../hooks/useIsLoggedIn';

export interface AuctionVolumesProps {}

// eslint-disable-next-line @typescript-eslint/naming-convention
const INITIAL_TABLE_STATE = {
  sorting: [
    {
      id: 'element_number',
      desc: false,
    },
  ],
};

const AuctionVolumes = ({}: AuctionVolumesProps) => {
  const { t } = useTranslation();
  const rfpId = useSelector((store) => store.rfp.data.id);
  const columns = useColumns();
  const navigate = useNavigate();
  const { data: auctionVolumes } = useProsforaAuctionVolumes(rfpId);
  const isLoggedIn = useIsLoggedIn();

  const onRowClick = useCallback(
    (row: Row<ProsforaAuctionVolume>) => {
      navigate(`/rfp/${rfpId}/element/${row.original.id}`);
    },
    [navigate, rfpId],
  );

  return (
    <section className="enkrateia-auction-volumes">
      <h2>{t('pages.prosforaProject.volumes.title')}</h2>
      <Table
        columns={columns}
        data={auctionVolumes}
        initialState={INITIAL_TABLE_STATE}
        onRowClick={isLoggedIn ? onRowClick : undefined}
      />
    </section>
  );
};

export default AuctionVolumes;
